/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

// This is a proxy for the `window` object,
// you can add logic to replace the default global object.
// Function('return this')();
const root = window;

export default root;
